module.exports = __webpack_public_path__ + "img/modalContent-2.ada391c9.svg";